export default __webpack_public_path__ + "static/media/create-profile-modal.f5a82f65.png";